import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { MonitorSmartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const MobileBlockedView = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <div className="hidden min-h-screen items-center justify-center bg-denim-500 px-6 text-center max-am-lg:flex">
      <div className="flex max-w-md flex-col items-center gap-4">
        <MonitorSmartphone className="size-12 text-teal-300" aria-hidden />
        <h1 className="text-denim-100 text-xl font-medium">{t('Layout.MobileBlocked.title')}</h1>
        <p className="text-denim-200 text-sm leading-5">{t('Layout.MobileBlocked.description')}</p>
      </div>
    </div>
  );
};
